import React from 'react';
import { Link } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'; 
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader'
import CardActions from '@material-ui/core/CardActions'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Zoom from '@material-ui/core/Zoom';
import BlackStoneIcon from '@material-ui/icons/Lens'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import SearchIcon from '@material-ui/icons/Search'
import ViewListIcon from '@material-ui/icons/ViewList'
import ViewModuleIcon from '@material-ui/icons/ViewModule'
import WhiteStoneIcon from '@material-ui/icons/PanoramaFishEye'
import WifiTetheringIcon from '@material-ui/icons/WifiTethering'

import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'

import { makeGameResultStr, makePath } from '../../../lib'
import { RenjuBoard, TitleGrid, Word } from '../../../containers'
import { liveStatus, liveListViewMode, OPENING_RULE } from '../../../constants'
import Fade from '@material-ui/core/Fade';
import { WID, getWord } from '../../../constants/Language';
import { useEffect } from 'react';
import { useContext } from 'react';
import { SettingsContext } from '../../../Parts/Settings';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  grid: {
    width: '100%',
    maxWidth: '1200px',
    margin: '24px auto',
  },
  button: {
    fontSize: '1em',
    margin: theme.spacing.unit,
  },
  gridTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing.unit * 4,
    color: theme.palette.text.secondary,
  },
  gridLiveNow: {
    padding: 0,
    marginBottom: theme.spacing.unit * 5,
  },
  gridBoard: {
    borderBottom: '1px solid ' + theme.palette.grey['100']
  },
  titleBox: {
    position: 'absolute',
    bottom: '10%',
    left: 0,
    right: 0,
    padding: 10,
    width: '80%',
    margin: '0 auto',
    backgroundColor: '#00000099',
  },
  stoneIcon: {
    fontSize:'0.875rem',
    verticalAlign: 'middle',
    marginRight: theme.spacing.unit,
  },
  gameTitleGrid: {
    padding: theme.spacing.unit / 2,
  },
  gameTitle: {
    lineHeight:'1.75em',
    marginLeft: theme.spacing.unit * 2,
    width: 'calc(100% - 100px)',
  },
  gameTitleForTable: {
    lineHeight:'1.75em',
    display: 'inline',
  },
  playerBox: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  playerName: {
    lineHeight:'2em',
    marginLeft: theme.spacing.unit,
  },
  gameResult: {
    position: 'absolute',
    bottom: 30,
    left: 0,
    right: 0,
    width: 125,
    margin: '0 auto',
    padding: '8px 16px 8px 16px',
    borderRadius: 30,
    lineHeight: '1.5em',
    textAlign: 'center',
    backgroundColor: 'white',
    boxShadow: theme.shadows[1],
  },
  gameResultForTable: {
    marginLeft: theme.spacing.unit * 1,
    lineHeight: '2em',
  },
  fixedButtons: {
    display: 'flex',
    position: 'fixed',
    bottom: theme.spacing.unit * 1,
    right: theme.spacing.unit * 1,
  },
  wifiTetheringIcon: {
    marginRight: theme.spacing.unit,
  },
  boardHead: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  contributor: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    marginTop: 0,
    marginRight: theme.spacing.unit,
    marginBottom: 0,
    marginLeft: theme.spacing.unit,
    width: 24,
    height: 24,
  },
  displayName: {
    color: theme.palette.grey['700']
  },
  liveMark: {
    display: 'inline',
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    marginRight: theme.spacing.unit * 2,
    padding: '3px 12px',
    height: 18,
    fontSize: '0.75em',
    boxShadow: theme.shadows[1],
  },
  archiveMark: {
    display: 'inline',
    backgroundColor: theme.palette.grey['500'],
    color: 'white',
    marginRight: theme.spacing.unit * 2,
    padding: '3px 12px',
    height: 18,
    fontSize: '0.75em',
    boxShadow: theme.shadows[1],
  },
  cardHeaderAction: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  searchIcon: {
    margin: theme.spacing.unit,
    color: theme.palette.grey['500']
  },
  searchTextField: {
  },
  cardActions: {
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: 0,
    justifyContent: 'flex-end',
  },
  pageNaviText: {
    color: theme.palette.grey['500']
  },
});

const GameList = withStyles(styles, { withTheme: true })((props) => {
  const { classes, theme, viewMode, boards, isFetching } = props
  var stoneIcon, linkTo, title, blackPlayerName, whitePlayerName, gameEndNumber, gameResult, gameResultStr

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const showGrid = (classes, theme, isFetching, index, linkTo, board, title, blackPlayerName, whitePlayerName, gameResultStr, stoneIcon) => {
    return (
      <Fade in={!isFetching} key={index}>
      <Grid item xs={12} md={4} sm={6} className={classes.gridBoard}>
        <Link to={linkTo} style={{textDecoration: 'none'}}>
          <Grid container spacing={0} style={{paddingTop:24, paddingBottom: 24}}>
            <Grid item xs={12}>
              <div className={classes.boardHead}>
                <Typography component={'span'} noWrap className={classes.gameTitle}>{title}</Typography>
                {board.status === liveStatus.OPEN && (
                  <Typography component={'span'} className={classes.liveMark}><Word wid={WID.LIVE_LIST.STATUS_MARK.LIVE}/></Typography>
                )}
                {board.status !== liveStatus.OPEN && (
                  <Typography component={'span'} className={classes.archiveMark}><Word wid={WID.LIVE_LIST.STATUS_MARK.FINISH}/></Typography>
                )}
              </div>
            </Grid>
            <Grid item xs={12} className={classes.gameTitleGrid} style={{paddingTop: 16}}>
              <div className={classes.playerBox}>
                <Typography noWrap className={classes.playerName}>
                  {blackPlayerName && (
                    <React.Fragment>
                      <BlackStoneIcon className={classes.stoneIcon}/>
                      {blackPlayerName}
                    </React.Fragment>
                  )}
                  {!blackPlayerName && ('-')}
                </Typography>
                <Typography noWrap className={classes.playerName}>
                  {whitePlayerName && (
                    <React.Fragment>
                      <WhiteStoneIcon className={classes.stoneIcon}/>
                      {whitePlayerName}
                    </React.Fragment>
                  )}
                  {!whitePlayerName && ('-')}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} style={{position:'relative'}}>
              <RenjuBoard
                type='View'
                moves={board.moves}
                marks={board.moves[board.moves.length - 1].marks}
                isVisibleNumber={true}
              />
              {gameResultStr && (
                <Typography noWrap className={classes.gameResult}>
                  {stoneIcon}
                  {gameResultStr}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <div className={classes.contributor}>
                <Avatar
                  alt={board.contributor.displayName}
                  src={board.contributor.photoURL}
                  className={classes.avatar}
                />
                <Typography className={classes.displayName} noWrap>
                  {board.contributor.displayName}
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Link>
      </Grid>
      </Fade>
    )
  }

  const showTable = (classes, theme, isFetching, index, linkTo, board, title, blackPlayerName, whitePlayerName, gameResultStr, stoneIcon) => {
    return (
      <Fade in={!isFetching} key={index}>
      <Grid item xs={12} md={6} style={{borderBottom: '1px solid #f0f0f0', paddingBottom: 8, paddingTop: 16}}>
        <Link to={linkTo} style={{textDecoration: 'none'}}>
          <Grid container spacing={8}>
            <Grid item xs={12} md={12} sm={12}>
              {board.status === liveStatus.OPEN && (
                <Typography component={'span'} className={classes.liveMark}><Word wid={WID.LIVE_LIST.STATUS_MARK.LIVE}/></Typography>
              )}
              {board.status !== liveStatus.OPEN && (
                <Typography component={'span'} className={classes.archiveMark}><Word wid={WID.LIVE_LIST.STATUS_MARK.FINISH}/></Typography>
              )}
              <Typography component={'span'} className={classes.gameTitleForTable}>{title}</Typography>
            </Grid>
            <Grid item xs={8}>
              <Grid container>
                <Grid item xs={12} md={6} sm={6}>
                  {blackPlayerName && (
                    <Typography noWrap className={classes.playerName}>
                      <BlackStoneIcon className={classes.stoneIcon}/>
                      {blackPlayerName}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12} md={6} sm={6}>
                  {whitePlayerName && (
                    <Typography noWrap className={classes.playerName}>
                      <WhiteStoneIcon className={classes.stoneIcon}/>
                      {whitePlayerName}
                    </Typography>
                  )}
                </Grid>
                {gameResultStr && (
                  <Grid item xs={12} md={12} sm={12} style={{marginTop: 16}}>
                    <Typography noWrap className={classes.gameResultForTable}>
                      {stoneIcon}
                      {gameResultStr}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <RenjuBoard type='View' moves={board.moves}/>
            </Grid>
            <Grid item xs={8}>
              <div className={classes.contributor}>
                <Avatar
                  alt={board.contributor.displayName}
                  src={board.contributor.photoURL}
                  className={classes.avatar}
                />
                <Typography className={classes.displayName} noWrap>
                  {board.contributor.displayName}
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Link>
      </Grid>
      </Fade>
    )
  }

  return (
  <Grid container spacing={16}>
    {boards.map((board, index) => {
      linkTo = makePath('/live/' + board.liveId, language)
      title = board.gameInfo && board.gameInfo.title ? board.gameInfo.title : 'untitled'
      if (board.gameInfo.openingRule && board.gameInfo.openingRule === OPENING_RULE.SOOSYRV8) {
        if (board.gameInfo.openingRule && board.gameInfo.openingRule === OPENING_RULE.SOOSYRV8 && board.gameInfo.soosyrv8) {
          let swapCount = 0
          if (board.gameInfo.soosyrv8.swap1 === true) swapCount++
          if (board.gameInfo.soosyrv8.swap2 === true) swapCount++
          if (swapCount % 2 === 1) {
            blackPlayerName = board.gameInfo && board.gameInfo.whitePlayerName ? board.gameInfo.whitePlayerName : undefined
            whitePlayerName = board.gameInfo && board.gameInfo.blackPlayerName ? board.gameInfo.blackPlayerName : undefined
          }
          else {
            blackPlayerName = board.gameInfo && board.gameInfo.blackPlayerName ? board.gameInfo.blackPlayerName : undefined
            whitePlayerName = board.gameInfo && board.gameInfo.whitePlayerName ? board.gameInfo.whitePlayerName : undefined
          }
        }
      }
      else {
        blackPlayerName = board.gameInfo && board.gameInfo.blackPlayerName ? board.gameInfo.blackPlayerName : undefined
        whitePlayerName = board.gameInfo && board.gameInfo.whitePlayerName ? board.gameInfo.whitePlayerName : undefined
      }
      gameEndNumber = board.gameInfo && board.gameInfo.gameEndNumber ? board.gameInfo.gameEndNumber: ''
      gameResult = board.gameInfo && board.gameInfo.gameResult ? board.gameInfo.gameResult: ''
      if (gameEndNumber !== '' && gameResult !== '') {
        gameResultStr = makeGameResultStr(board.gameInfo.gameEndNumber, board.gameInfo.gameResult)
        if (gameEndNumber.indexOf('black')) {
          stoneIcon = <WhiteStoneIcon className={classes.stoneIcon}/>
        }
        else {
          stoneIcon = <BlackStoneIcon className={classes.stoneIcon}/>
        }
      }
      else {
        stoneIcon = null
        gameResultStr = null
      }
      switch (viewMode) {
        case liveListViewMode.GRID:
          return showGrid(classes, theme, isFetching, index, linkTo, board, title, blackPlayerName, whitePlayerName, gameResultStr, stoneIcon)
        case liveListViewMode.TABLE:
          return showTable(classes, theme, isFetching, index, linkTo, board, title, blackPlayerName, whitePlayerName, gameResultStr, stoneIcon)
        default:
          return (<div key={index}></div>)
      }
    })}
  </Grid>
)})

function LiveList(props) {
  useEffect(() => {
    if (props.socket) {
      props.init(props.rowsPerPage)
    }
    return () => {
      props.clear()
    }
  },[props.socket])

  const { classes, theme, user, viewMode, boards, page, rowsPerPage, pageNaviText, search, totalRows, enableNextPage, enableBackPage, isFetching, handleClickListButton, handleClickGridButton, handleChangeText, handleClickLeft, handleClickRight, handleKeyDown, language } = props
  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  }
  return (
    <div className={classes.root}>
      <TitleGrid titleType='live'>
        <Grid item xs={12} className={classes.gridLiveNow}>
          <Card style={{padding: '16px'}}>
            <CardHeader
              action={
                <div className={classes.cardHeaderAction}>
                  <SearchIcon className={classes.searchIcon}/>
                  <TextField
                    className={classes.searchTextField}
                    placeholder={getWord(WID.LIVE_LIST.SEARCH_PLACE_HOLDER, language)}
                    onChange={handleChangeText}
                    onKeyDown={handleKeyDown(rowsPerPage)}
                  />
                  {viewMode === liveListViewMode.GRID && (
                    <IconButton onClick={handleClickListButton}>
                      <ViewListIcon/>
                    </IconButton>
                  )}
                  {viewMode === liveListViewMode.TABLE && (
                    <IconButton onClick={handleClickGridButton}>
                      <ViewModuleIcon/>
                    </IconButton>
                  )}
                </div>
              }
              style={{justifyContent: 'flex-end'}}
            />
            {search && totalRows > 0 && (
              <Typography><Word wid={WID.LIVE_LIST.SEARCH_RESULT.FIND} insert={{search, totalRows}}/></Typography>
            )}
            {search && !totalRows && (
              <Typography><Word wid={WID.LIVE_LIST.SEARCH_RESULT.DONT_FIND} insert={{search}}/></Typography>
            )}
            {boards.length > 0 && (
              <GameList boards={boards} viewMode={viewMode} isFetching={isFetching} language={language}/>
            )}
            <CardActions className={classes.cardActions}>
              <Typography className={classes.pageNaviText}>{pageNaviText}</Typography>
              <IconButton onClick={handleClickLeft(page, rowsPerPage, search)} disabled={!enableBackPage}>
                <ChevronLeftIcon/>
              </IconButton>
              <IconButton onClick={handleClickRight(page, rowsPerPage, search)} disabled={!enableNextPage}>
                <ChevronRightIcon/>
              </IconButton>
            </CardActions>
          </Card>
        </Grid>
      </TitleGrid>
      <div className={classes.fixedButtons}>
        <Zoom
            in={Boolean(user)}
            timeout={transitionDuration}
            style={{
              transitionDelay: `${Boolean(user) ? transitionDuration.exit : 0}ms`,
            }}
            unmountOnExit
        >
          <div className={classes.buttonBox}>
            <Typography align='center' color='primary'><Word wid={WID.LIVE_LIST.FIXED_BUTTONS.START_LIVE}/></Typography>
            <Button variant="fab" className={classes.button} color="primary" component={Link} to='/live/settings'>
              <WifiTetheringIcon/>
            </Button>
          </div>
        </Zoom>
      </div>
    </div>
  );
}

export default withStyles(styles, { withTheme: true })(LiveList);



// WEBPACK FOOTER //
// ./src/Pages/Live/components/LiveList.js